/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseBillsInnerPaymentsInner
 */
export interface GetReportTab200ResponseBillsInnerPaymentsInner {
    /**
     * 
     * @type {boolean}
     * @memberof GetReportTab200ResponseBillsInnerPaymentsInner
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseBillsInnerPaymentsInner
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseBillsInnerPaymentsInner
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseBillsInnerPaymentsInner
     */
    tip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseBillsInnerPaymentsInner
     */
    change?: number;
}

/**
 * Check if a given object implements the GetReportTab200ResponseBillsInnerPaymentsInner interface.
 */
export function instanceOfGetReportTab200ResponseBillsInnerPaymentsInner(value: object): value is GetReportTab200ResponseBillsInnerPaymentsInner {
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseBillsInnerPaymentsInnerFromJSON(json: any): GetReportTab200ResponseBillsInnerPaymentsInner {
    return GetReportTab200ResponseBillsInnerPaymentsInnerFromJSONTyped(json, false);
}

export function GetReportTab200ResponseBillsInnerPaymentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseBillsInnerPaymentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'deleted': json['deleted'],
        'type': json['type'],
        'amount': json['amount'],
        'tip': json['tip'] == null ? undefined : json['tip'],
        'change': json['change'] == null ? undefined : json['change'],
    };
}

export function GetReportTab200ResponseBillsInnerPaymentsInnerToJSON(json: any): GetReportTab200ResponseBillsInnerPaymentsInner {
    return GetReportTab200ResponseBillsInnerPaymentsInnerToJSONTyped(json, false);
}

export function GetReportTab200ResponseBillsInnerPaymentsInnerToJSONTyped(value?: GetReportTab200ResponseBillsInnerPaymentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deleted': value['deleted'],
        'type': value['type'],
        'amount': value['amount'],
        'tip': value['tip'],
        'change': value['change'],
    };
}

